import { render, staticRenderFns } from "./HomeHero.vue?vue&type=template&id=65a36419&scoped=true"
import script from "./HomeHero.vue?vue&type=script&lang=ts"
export * from "./HomeHero.vue?vue&type=script&lang=ts"
import style0 from "./HomeHero.vue?vue&type=style&index=0&id=65a36419&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a36419",
  null
  
)

export default component.exports